import styled from 'styled-components';

export const ProviderStyle = styled.div``;
